// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validation-address-view-layer {
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
}

.validation-address-view {
  background: #ffffff;
  position: fixed;
  max-width: 44rem;
  margin: auto;
  padding: 2.5em;
  left: 50%;
  transform: translateX(-50%);
  top: 5rem;
  border-radius: 12px;
  font-size: 1em;
  z-index: 2;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}
.validation-address-view h1 {
  color: var(--ods-color-purple-60);
  font-size: 1.75em;
  padding-bottom: 1.5em;
  text-align: center;
  font-weight: 600;
}
.validation-address-view .address-view {
  display: flex;
  justify-content: center;
  gap: 1.5em;
}
.validation-address-view .address-view .address-card {
  flex: 1;
  max-width: 16rem;
  padding: 1.5em;
  border: 2px solid var(--ods-color-gray-20);
  border-radius: 12px;
  background-color: var(--ods-color-white);
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;
}
.validation-address-view .address-view .address-card:hover {
  border-color: var(--ods-color-purple-40);
  box-shadow: 0 4px 12px rgba(107, 73, 132, 0.1);
}
.validation-address-view .address-view .address-card.selected {
  border-color: var(--ods-color-purple-60);
  box-shadow: 0 4px 16px rgba(107, 73, 132, 0.2);
  background-color: var(--ods-color-purple-5, #faf8fc);
}
.validation-address-view .address-view .address-card.recommended {
  border-color: var(--ods-color-purple-40);
}
.validation-address-view .address-view .address-card.recommended.selected {
  border-color: var(--ods-color-purple-60);
}
.validation-address-view .address-view .address-card .recommended-badge {
  position: absolute;
  top: -0.75em;
  right: 1em;
  display: flex;
  align-items: center;
  gap: 0.35em;
  background-color: var(--ods-color-purple-60);
  color: var(--ods-color-white);
  padding: 0.25em 0.75em;
  border-radius: 1em;
  font-size: 0.75em;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(107, 73, 132, 0.3);
}
.validation-address-view .address-view .address-card .recommended-badge__icon {
  font-size: 0.85em;
}
.validation-address-view .address-view .address-card .recommended-badge__text {
  letter-spacing: 0.02em;
}
.validation-address-view .address-view .address-card label {
  cursor: pointer;
  display: block;
}
.validation-address-view .address-view .address-card input[type=radio] {
  position: absolute;
  left: 1em;
  top: 1.5em;
  width: 1.15em;
  height: 1.15em;
  accent-color: var(--ods-color-purple-60);
  cursor: pointer;
}
.validation-address-view .address-view .address-card__content {
  margin-left: 1.75em;
}
.validation-address-view .address-view .address-card__header {
  font-weight: 700;
  margin-bottom: 0.75em;
  font-size: 1.1em;
  color: var(--ods-color-gray-80);
}
.validation-address-view .address-view .address-card address {
  font-style: normal;
  line-height: 1.6;
  margin: 0;
  font-size: 0.95em;
  color: var(--ods-color-gray-70);
}
.validation-address-view p {
  margin-top: 2em;
  text-align: center;
  font-size: 0.9em;
  color: var(--ods-color-gray-60);
  line-height: 1.6;
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}
.validation-address-view .btn-view {
  display: flex;
  justify-content: center;
  gap: 1em;
  margin-top: 2em;
}
.validation-address-view .btn-view button {
  padding: 0.85em 2em;
  font-size: 0.95em;
  color: var(--ods-color-white) !important;
  text-align: center;
  border: none;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
}
.validation-address-view .btn-view button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.validation-address-view .btn-view button:active {
  transform: translateY(0);
}
.validation-address-view .btn-view .btn-search {
  background-color: var(--ods-color-purple-60);
}
.validation-address-view .btn-view .btn-search:hover {
  background-color: var(--ods-color-purple-70);
}
.validation-address-view .btn-view .btn-close {
  background-color: var(--ods-color-gray-60);
}
.validation-address-view .btn-view .btn-close:hover {
  background-color: var(--ods-color-gray-70);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/validation-address/validation-address.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;AACF;AACE;EACE,iCAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,UAAA;AAAJ;AAEI;EACE,OAAA;EACA,gBAAA;EACA,cAAA;EACA,0CAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAAN;AAEM;EACE,wCAAA;EACA,8CAAA;AAAR;AAGM;EACE,wCAAA;EACA,8CAAA;EACA,oDAAA;AADR;AAIM;EACE,wCAAA;AAFR;AAKM;EACE,wCAAA;AAHR;AAMM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4CAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6CAAA;AAJR;AAMQ;EACE,iBAAA;AAJV;AAOQ;EACE,sBAAA;AALV;AASM;EACE,eAAA;EACA,cAAA;AAPR;AAUM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,wCAAA;EACA,eAAA;AARR;AAWM;EACE,mBAAA;AATR;AAYM;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,+BAAA;AAVR;AAaM;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,+BAAA;AAXR;AAiBE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAfJ;AAmBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAjBJ;AAmBI;EACE,mBAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAjBN;AAmBM;EACE,2BAAA;EACA,0CAAA;AAjBR;AAoBM;EACE,wBAAA;AAlBR;AAsBI;EACE,4CAAA;AApBN;AAsBM;EACE,4CAAA;AApBR;AAwBI;EACE,0CAAA;AAtBN;AAwBM;EACE,0CAAA;AAtBR","sourcesContent":[".validation-address-view-layer {\n  background-color: rgba(0, 0, 0, 0.8);\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 1;\n}\n\n.validation-address-view {\n  background: #ffffff;\n  position: fixed;\n  max-width: 44rem;\n  margin: auto;\n  padding: 2.5em;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 5rem;\n  border-radius: 12px;\n  font-size: 1em;\n  z-index: 2;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n\n  h1 {\n    color: var(--ods-color-purple-60);\n    font-size: 1.75em;\n    padding-bottom: 1.5em;\n    text-align: center;\n    font-weight: 600;\n  }\n\n  .address-view {\n    display: flex;\n    justify-content: center;\n    gap: 1.5em;\n\n    .address-card {\n      flex: 1;\n      max-width: 16rem;\n      padding: 1.5em;\n      border: 2px solid var(--ods-color-gray-20);\n      border-radius: 12px;\n      background-color: var(--ods-color-white);\n      transition: all 0.2s ease;\n      position: relative;\n      cursor: pointer;\n\n      &:hover {\n        border-color: var(--ods-color-purple-40);\n        box-shadow: 0 4px 12px rgba(107, 73, 132, 0.1);\n      }\n\n      &.selected {\n        border-color: var(--ods-color-purple-60);\n        box-shadow: 0 4px 16px rgba(107, 73, 132, 0.2);\n        background-color: var(--ods-color-purple-5, #faf8fc);\n      }\n\n      &.recommended {\n        border-color: var(--ods-color-purple-40);\n      }\n\n      &.recommended.selected {\n        border-color: var(--ods-color-purple-60);\n      }\n\n      .recommended-badge {\n        position: absolute;\n        top: -0.75em;\n        right: 1em;\n        display: flex;\n        align-items: center;\n        gap: 0.35em;\n        background-color: var(--ods-color-purple-60);\n        color: var(--ods-color-white);\n        padding: 0.25em 0.75em;\n        border-radius: 1em;\n        font-size: 0.75em;\n        font-weight: 600;\n        box-shadow: 0 2px 6px rgba(107, 73, 132, 0.3);\n\n        &__icon {\n          font-size: 0.85em;\n        }\n\n        &__text {\n          letter-spacing: 0.02em;\n        }\n      }\n\n      label {\n        cursor: pointer;\n        display: block;\n      }\n\n      input[type=\"radio\"] {\n        position: absolute;\n        left: 1em;\n        top: 1.5em;\n        width: 1.15em;\n        height: 1.15em;\n        accent-color: var(--ods-color-purple-60);\n        cursor: pointer;\n      }\n\n      &__content {\n        margin-left: 1.75em;\n      }\n\n      &__header {\n        font-weight: 700;\n        margin-bottom: 0.75em;\n        font-size: 1.1em;\n        color: var(--ods-color-gray-80);\n      }\n\n      address {\n        font-style: normal;\n        line-height: 1.6;\n        margin: 0;\n        font-size: 0.95em;\n        color: var(--ods-color-gray-70);\n      }\n    }\n  }\n\n  // Instructional text styling\n  p {\n    margin-top: 2em;\n    text-align: center;\n    font-size: 0.9em;\n    color: var(--ods-color-gray-60);\n    line-height: 1.6;\n    max-width: 36rem;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  // Styling for the action buttons\n  .btn-view {\n    display: flex;\n    justify-content: center;\n    gap: 1em;\n    margin-top: 2em;\n\n    button {\n      padding: 0.85em 2em;\n      font-size: 0.95em;\n      color: var(--ods-color-white) !important;\n      text-align: center;\n      border: none;\n      font-weight: 600;\n      border-radius: 6px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      min-width: 160px;\n\n      &:hover {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n    }\n\n    .btn-search {\n      background-color: var(--ods-color-purple-60);\n\n      &:hover {\n        background-color: var(--ods-color-purple-70);\n      }\n    }\n\n    .btn-close {\n      background-color: var(--ods-color-gray-60);\n\n      &:hover {\n        background-color: var(--ods-color-gray-70);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
